import { motion } from 'framer-motion';
import { ReactNode } from 'react';

type P = {
  children: ReactNode;
};

const AnimationOpen = ({ children }: P) => {
  return (
    <motion.div
      initial={{ height: 0, opacity: 0 }} // 초기 상태: 높이 0, 투명
      animate={{ height: 'auto', opacity: 1 }} // 열릴 때: 높이 자동, 투명도 1
      exit={{ height: 0, opacity: 0 }} // 닫힐 때: 높이 0, 투명
      transition={{ duration: 0.3, ease: 'easeInOut' }} // 전환 시간 및 속도
    >
      {children}
    </motion.div>
  );
};

export default AnimationOpen;
